import React from 'react';

const Datenschutz = () => {
  return (
    <div className="sterbegeld-landing">
      <section className="section">
        <div className="container-custom" style={{ maxWidth: '900px' }}>
          <h1 style={{ marginBottom: '2rem', textAlign: 'center' }}>Datenschutzerklärung</h1>
          
          <div style={{ background: 'white', padding: '3rem', borderRadius: '24px', boxShadow: 'var(--shadow-md)', lineHeight: '1.8' }}>
            
            {/* 1. Verantwortlicher */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>1. Verantwortlicher für die Datenverarbeitung</h2>
              <p style={{ marginBottom: '0.5rem' }}><strong>Marcel Peev</strong></p>
              <p style={{ marginBottom: '0.5rem' }}>Bahnhofstraße 35</p>
              <p style={{ marginBottom: '0.5rem' }}>42651 Solingen</p>
              <p style={{ marginBottom: '0.5rem' }}>Telefon: <a href="tel:+4921288137120" style={{ color: 'var(--primary)' }}>0212 88137120</a></p>
              <p style={{ marginBottom: '0.5rem' }}>E-Mail: <a href="mailto:marcel.peev@allianz.de" style={{ color: 'var(--primary)' }}>marcel.peev@allianz.de</a></p>
            </div>

            {/* 2. Datenerhebung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>2. Erhebung und Speicherung personenbezogener Daten</h2>
              <p style={{ marginBottom: '1rem' }}>
                Wenn Sie uns über unser Kontaktformular eine Anfrage zur Sterbegeldversicherung senden, erheben wir folgende Daten:
              </p>
              <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li><strong>Vorname und Nachname:</strong> Zur persönlichen Ansprache und Identifikation</li>
                <li><strong>Geburtsdatum:</strong> Zur Berechnung der Versicherungsprämie und Tarifauswahl</li>
                <li><strong>Telefonnummer:</strong> Zur telefonischen Kontaktaufnahme und Beratung</li>
                <li><strong>E-Mail-Adresse:</strong> Zur schriftlichen Kommunikation und Zusendung von Angeboten</li>
                <li><strong>Gewünschte Versicherungssumme:</strong> Zur individuellen Angebotsgestaltung</li>
                <li><strong>Rückrufwunsch (optional):</strong> Zur Planung der Kontaktaufnahme</li>
              </ul>
              <p>
                Zusätzlich werden automatisch folgende technische Daten erhoben: IP-Adresse, Datum und Uhrzeit der Anfrage, 
                Browser-Typ und Betriebssystem (für technische Zwecke und Sicherheit).
              </p>
            </div>

            {/* 3. Zweck der Datenverarbeitung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>3. Zweck der Datenverarbeitung</h2>
              <p style={{ marginBottom: '1rem' }}>
                Ihre personenbezogenen Daten werden ausschließlich für folgende Zwecke verarbeitet:
              </p>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li>Bearbeitung Ihrer Anfrage zur Sterbegeldversicherung</li>
                <li>Persönliche und individuelle Beratung zu Versicherungsprodukten</li>
                <li>Erstellung eines maßgeschneiderten Angebots</li>
                <li>Telefonische oder schriftliche Kontaktaufnahme zur Terminvereinbarung</li>
                <li>Dokumentation der Anfrage für interne Qualitätssicherung</li>
              </ul>
            </div>

            {/* 4. Rechtsgrundlage */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>4. Rechtsgrundlage</h2>
              <p style={{ marginBottom: '1rem' }}>
                Die Verarbeitung Ihrer personenbezogenen Daten erfolgt auf Grundlage von:
              </p>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li><strong>Art. 6 Abs. 1 lit. b DSGVO:</strong> Die Verarbeitung ist erforderlich zur Durchführung vorvertraglicher Maßnahmen, die auf Ihre Anfrage hin erfolgen (Beratung, Angebotserstellung).</li>
                <li><strong>Art. 6 Abs. 1 lit. a DSGVO:</strong> Sie erteilen uns durch Absenden des Formulars Ihre ausdrückliche Einwilligung zur Datenverarbeitung.</li>
                <li><strong>Art. 6 Abs. 1 lit. f DSGVO:</strong> Die Verarbeitung ist zur Wahrung unserer berechtigten Interessen erforderlich (Kundenakquise, Beratungsdienstleistung).</li>
              </ul>
            </div>

            {/* 5. Weitergabe von Daten */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>5. Weitergabe von Daten an Dritte</h2>
              <p style={{ marginBottom: '1rem' }}>
                Ihre Daten werden zur Bearbeitung Ihrer Anfrage an folgende Dritte weitergegeben:
              </p>
              <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li><strong>Monday.com (Work OS):</strong> Zur Verwaltung und Organisation von Kundenanfragen nutzen wir die CRM-Plattform Monday.com. 
                Ihre Daten werden dort sicher gespeichert und nur von autorisierten Mitarbeitern eingesehen. 
                Monday.com ist DSGVO-konform und hat einen Auftragsverarbeitungsvertrag (AVV) mit uns abgeschlossen.</li>
                <li><strong>Allianz Versicherungsunternehmen:</strong> Als gebundener Versicherungsvertreter der Allianz geben wir Ihre Daten 
                zur Angebotserstellung und Vertragsverwaltung an die zuständigen Versicherungsgesellschaften der Allianz weiter.</li>
              </ul>
              <p>
                Eine Weitergabe Ihrer Daten an weitere Dritte erfolgt nicht, es sei denn, wir sind gesetzlich dazu verpflichtet 
                oder Sie haben ausdrücklich eingewilligt.
              </p>
            </div>

            {/* 6. Speicherdauer */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>6. Speicherdauer</h2>
              <p style={{ marginBottom: '1rem' }}>
                Ihre personenbezogenen Daten werden gespeichert, solange dies für die Bearbeitung Ihrer Anfrage und die 
                Durchführung der Beratung erforderlich ist.
              </p>
              <ul style={{ paddingLeft: '1.5rem' }}>
                <li><strong>Im Falle eines Vertragsabschlusses:</strong> Speicherung gemäß gesetzlicher Aufbewahrungsfristen (10 Jahre nach § 257 HGB).</li>
                <li><strong>Ohne Vertragsabschluss:</strong> Ihre Daten werden nach Abschluss der Beratung und nach Ablauf etwaiger 
                Gewährleistungs- oder Verjährungsfristen (in der Regel 3 Jahre) gelöscht.</li>
                <li><strong>Widerruf Ihrer Einwilligung:</strong> Bei Widerruf werden Ihre Daten unverzüglich gelöscht, 
                sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
              </ul>
            </div>

            {/* 7. Ihre Rechte */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>7. Ihre Rechte als betroffene Person</h2>
              <p style={{ marginBottom: '1rem' }}>
                Sie haben jederzeit das Recht:
              </p>
              <ul style={{ paddingLeft: '1.5rem', marginBottom: '1rem' }}>
                <li><strong>Auskunft (Art. 15 DSGVO):</strong> Sie können Auskunft über Ihre gespeicherten personenbezogenen Daten verlangen.</li>
                <li><strong>Berichtigung (Art. 16 DSGVO):</strong> Sie können die Berichtigung unrichtiger oder unvollständiger Daten verlangen.</li>
                <li><strong>Löschung (Art. 17 DSGVO):</strong> Sie können die Löschung Ihrer Daten verlangen, sofern keine gesetzlichen Aufbewahrungspflichten bestehen.</li>
                <li><strong>Einschränkung der Verarbeitung (Art. 18 DSGVO):</strong> Sie können die Einschränkung der Verarbeitung Ihrer Daten verlangen.</li>
                <li><strong>Datenübertragbarkeit (Art. 20 DSGVO):</strong> Sie können Ihre Daten in einem strukturierten, gängigen und maschinenlesbaren Format erhalten.</li>
                <li><strong>Widerspruch (Art. 21 DSGVO):</strong> Sie können der Verarbeitung Ihrer Daten aus Gründen, die sich aus Ihrer besonderen Situation ergeben, jederzeit widersprechen.</li>
                <li><strong>Widerruf der Einwilligung (Art. 7 Abs. 3 DSGVO):</strong> Sie können Ihre erteilte Einwilligung jederzeit mit Wirkung für die Zukunft widerrufen.</li>
              </ul>
              <p style={{ marginBottom: '1rem' }}>
                Zur Ausübung Ihrer Rechte wenden Sie sich bitte an:
              </p>
              <p style={{ marginBottom: '0.5rem' }}><strong>Marcel Peev</strong></p>
              <p style={{ marginBottom: '0.5rem' }}>E-Mail: <a href="mailto:marcel.peev@allianz.de" style={{ color: 'var(--primary)' }}>marcel.peev@allianz.de</a></p>
              <p style={{ marginBottom: '0.5rem' }}>Telefon: <a href="tel:+4921288137120" style={{ color: 'var(--primary)' }}>0212 88137120</a></p>
            </div>

            {/* 8. Beschwerderecht */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>8. Beschwerderecht bei der Aufsichtsbehörde</h2>
              <p style={{ marginBottom: '1rem' }}>
                Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer personenbezogenen Daten gegen die DSGVO verstößt, 
                haben Sie das Recht, Beschwerde bei einer Datenschutz-Aufsichtsbehörde einzulegen (Art. 77 DSGVO).
              </p>
              <p style={{ marginBottom: '0.5rem' }}><strong>Zuständige Aufsichtsbehörde:</strong></p>
              <p style={{ marginBottom: '0.5rem' }}>Landesbeauftragte für Datenschutz und Informationsfreiheit Nordrhein-Westfalen</p>
              <p style={{ marginBottom: '0.5rem' }}>Kavalleriestraße 2-4</p>
              <p style={{ marginBottom: '0.5rem' }}>40213 Düsseldorf</p>
              <p style={{ marginBottom: '0.5rem' }}>Telefon: 0211 38424-0</p>
              <p>Website: <a href="https://www.ldi.nrw.de" target="_blank" rel="noopener noreferrer" style={{ color: 'var(--primary)' }}>www.ldi.nrw.de</a></p>
            </div>

            {/* 9. SSL-Verschlüsselung */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>9. SSL-/TLS-Verschlüsselung</h2>
              <p>
                Diese Website nutzt aus Sicherheitsgründen und zum Schutz der Übertragung vertraulicher Inhalte, 
                wie zum Beispiel Anfragen, die Sie an uns als Seitenbetreiber senden, eine SSL-/TLS-Verschlüsselung. 
                Eine verschlüsselte Verbindung erkennen Sie daran, dass die Adresszeile des Browsers von "http://" 
                auf "https://" wechselt und an dem Schloss-Symbol in Ihrer Browserzeile.
              </p>
            </div>

            {/* 10. Cookies */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>10. Verwendung von Cookies</h2>
              <p style={{ marginBottom: '1rem' }}>
                Diese Website verwendet lediglich technisch notwendige Cookies, die für den Betrieb der Website 
                erforderlich sind. Diese Cookies speichern keine personenbezogenen Daten und dienen ausschließlich 
                der Funktionalität und Sicherheit unserer Website.
              </p>
              <p>
                Für Analyse- und Marketing-Cookies wird Ihre ausdrückliche Einwilligung benötigt. 
                Diese Website setzt derzeit keine solchen Cookies ein.
              </p>
            </div>

            {/* 11. Änderungen */}
            <div style={{ marginBottom: '2.5rem' }}>
              <h2 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: 'var(--primary)' }}>11. Änderungen der Datenschutzerklärung</h2>
              <p>
                Wir behalten uns vor, diese Datenschutzerklärung anzupassen, damit sie stets den aktuellen rechtlichen 
                Anforderungen entspricht oder um Änderungen unserer Leistungen in der Datenschutzerklärung umzusetzen. 
                Für Ihren erneuten Besuch gilt dann die neue Datenschutzerklärung.
              </p>
            </div>

            {/* Stand */}
            <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #e0e0e0' }}>
              <p style={{ fontSize: '0.9rem', color: '#666' }}><strong>Stand dieser Datenschutzerklärung:</strong> Dezember 2025</p>
            </div>
          </div>

          <div style={{ marginTop: '3rem', textAlign: 'center' }}>
            <a href="/" className="btn-primary">Zurück zur Startseite</a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Datenschutz;
